<usimweb-dropdown
  placeholder="Moving surface"
  [values]="parts"
  [key]="key"
  [value]="_value"
  (selectionChange)="part = $event"
  [required]="true">
</usimweb-dropdown>

<usimweb-form-input
  [value]="gravity"
  placeholder="Opening vector"
  (selectionChange)="gravity = $event"
  [required]="true">
</usimweb-form-input>
